module.exports = __webpack_public_path__ + "img/Vivi.f0aaba5.png";